export var DrawType;
(function (DrawType) {
    DrawType[DrawType["DrawArray"] = 0] = "DrawArray";
    DrawType[DrawType["DrawArrayInstance"] = 1] = "DrawArrayInstance";
    DrawType[DrawType["DrawElement"] = 2] = "DrawElement";
    DrawType[DrawType["DrawElementInstance"] = 3] = "DrawElementInstance";
})(DrawType || (DrawType = {}));
